<ngx-ui-loader></ngx-ui-loader>
<rzm-header (navigateToSettings)="navigateToSettings()"></rzm-header>
<router-outlet></router-outlet>
<div id="terms" *ngIf="termsAndPrivacyAcknowledgmentService.displayTermsAndPrivacyAcknowledgment">
  <app-terms-and-privacy-acknowledgment></app-terms-and-privacy-acknowledgment>
</div>
<rzm-footer></rzm-footer>
<span style="color:#D4D7DB; font-size: 10px">{{gitInfo}}</span>
